import React, { Fragment } from "react";
import { Dialog, Transition, TransitionChild } from "@headlessui/react";

import useOnNavigate from "../../../../hooks/useOnNavigate";

import Icon, { Icons } from "../../Icon/Icon";
import ActiveLink from "../../ActiveLink";

import styles from "./MobileNavigation.module.css";
import Typography from "../../Typography/Typography";

interface Props {
    logo: string;
    isOpen?: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    links: { href: string; icon: Icons; label: string }[];
}

const MobileNavigation = ({ isOpen, onClose, children, links }: Props) => {
    useOnNavigate(onClose);

    return (
        <Transition show={isOpen} as={Dialog} onClose={onClose}>
            <Transition
                appear
                as="button"
                show={isOpen}
                type="button"
                disabled={!isOpen}
                tabIndex={-1}
                onClick={onClose}
                aria-hidden="true"
                className={styles.mask}
                enterFrom="!opacity-0"
                enterTo="opacity-75"
                leaveFrom="opacity-75"
                leaveTo="!opacity-0"
            />
            <TransitionChild
                as={Fragment}
                enter="transition-transform ease-default duration-fast"
                enterFrom="-translate-x-full"
                enterTo="translate-x-[0]"
                leave="transition-transform ease-default duration-fast"
                leaveFrom="translate-x-[0]"
                leaveTo="-translate-x-full"
            >
                <nav aria-label="Main navigation" className={styles.nav}>
                    <div className="flex justify-between items-center">
                        <Typography variant="heading" fontSize="300">Menu</Typography>
                        <button type="button" onClick={onClose} className="p-050 -mt-050 -mr-050">
                            <Icon icon="cross" />
                        </button>
                    </div>
                    <ul className="mt-050">
                        {links.map((link, index) => (
                            <li key={index}>
                                <ActiveLink
                                    href={link.href}
                                    activeClassName={styles.linkActive} className={styles.link}
                                    partiallyActive
                                >
                                    <Icon icon={link.icon} size="medium" />
                                    {link.label}
                                </ActiveLink>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-auto">
                        {children}
                    </div>
                </nav>
            </TransitionChild>
        </Transition>
    );
};

export default MobileNavigation;
